import { useSearch } from '@repo/doc-search';
import { Command, CommandEmpty, CommandInput, CommandList } from '@repo/ui';
import { useMemo } from 'react';
import { SearchItem } from './search-item';

interface SearchBarProps {
  displayEmpty?: boolean;
  limit?: number;
  grouped?: boolean;
}

export function SearchComponent({
  displayEmpty = false,
  limit = 5,
  grouped = false,
}: SearchBarProps) {
  const { search, handleSearch, searchResults } = useSearch({
    limit,
  });

  const memoizedCommandInput = useMemo(
    () => (
      <CommandInput
        //   className="shadow-xs"
        onValueChange={handleSearch}
        placeholder="Type search here..."
        value={search}
      />
    ),
    [handleSearch, search]
  );

  const memoizedCommandList = useMemo(
    () => (
      <CommandList>
        {displayEmpty ? (
          <CommandEmpty>
            <span className="text-muted-foreground">No results found.</span>
          </CommandEmpty>
        ) : null}
        {!grouped &&
          searchResults.map((r) => {
            return <SearchItem key={r.id} result={r} />;
          })}
      </CommandList>
    ),
    [displayEmpty, grouped, searchResults]
  );

  return (
    <>
      {memoizedCommandInput}
      {memoizedCommandList}
    </>
  );
}

export function SearchBar({ displayEmpty = false, limit = 5 }: SearchBarProps) {
  return (
    <div className="flex justify-center">
      <Command className="max-w-(--breakpoint-sm) rounded-lg border shadow-md md:min-w-[450px]">
        <SearchComponent displayEmpty={displayEmpty} limit={limit} />
      </Command>
    </div>
  );
}
